import React from 'react';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
interface StatCardProps {
  title: string;
  value: string;
  change: string;
  positive: boolean;
  icon: ReactNode;
}
export const StatCard = ({
  title,
  value,
  change,
  positive,
  icon
}: StatCardProps) => {
  return <div className="bg-white rounded-lg shadow p-5" data-id="element-570">
      <div className="flex justify-between" data-id="element-571">
        <div data-id="element-572">
          <p className="text-sm font-medium text-gray-500" data-id="element-573">{title}</p>
          <p className="text-2xl font-bold text-gray-800 mt-1" data-id="element-574">{value}</p>
        </div>
        <div className="p-2 rounded-full bg-gray-100" data-id="element-575">{icon}</div>
      </div>
      <div className="flex items-center mt-4" data-id="element-576">
        <div className={`flex items-center ${positive ? 'text-green-500' : 'text-red-500'}`} data-id="element-577">
          {positive ? <TrendingUpIcon size={16} className="mr-1" data-id="element-578" /> : <TrendingDownIcon size={16} className="mr-1" data-id="element-579" />}
          <span className="text-sm font-medium" data-id="element-580">{change}</span>
        </div>
        <span className="text-xs text-gray-500 ml-2" data-id="element-581">vs. letzten Monat</span>
      </div>
    </div>;
};